var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useLocation } from "react-router-dom";
import { FormClientsAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import PagesHeader from "ah_utility/PagesHeader";
import { useStepNavigation } from "ah_utility/NavigationEngine";
export var ClientsView = function (props) {
    var pathname = useLocation().pathname;
    var isLastPage = useStepNavigation({ currentStepId: pathname }).isLastPage;
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: "Clientes", hideStep: true, steps: [], completed: isLastPage }), _jsx("div", __assign({ style: { marginTop: "-28px" } }, { children: _jsx(FormClientsAFY, { title: props.title, columns: props.columns || [], rows: props.rows || [], onClickSeeDetails: props.onClickSeeDetails, onSearch: props.onSearch, listIdentificationType: props.listIdentificationType }) }))] }));
};
